var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var RemoteLink =
/*#__PURE__*/
function () {
  "use strict";

  function RemoteLink(values) {
    _classCallCheck(this, RemoteLink);

    Object.assign(this, values);
  } // Select which properties are going to be serialized,
  // to avoid JSON circular references


  _createClass(RemoteLink, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        url: this.url,
        meta: this.meta,
        type: this.type
      };
    }
  }]);

  return RemoteLink;
}();

module.exports = RemoteLink;